import {storage} from '@/utils'
export default {
  state:{
    merchantInfo: storage.get('merchantInfo') || {},
    merchantUser: storage.get('merchantUser') || {},
    token: storage.get('token')
  },
  mutations:{
    updateMerchantInfo(state, data){
      state.merchantInfo = data
    },
    updateMerchantUser(state, data){
      state.merchantUser = data
    },
    updateMerchantItem (state, data) {
      if (Object.prototype.toString.call(data) !== '[object Object]') {
        return
      }
      for (let [key, val] of Object.entries(data)) {
        state.merchantInfo[key] = val
      }
    },
    updateToken (state, token) {
      state.token = token
    }
  },
  actions: {
    updateMerchantInfo ({commit}, merchantInfo) {
      storage.set('merchantInfo', merchantInfo)
      commit('updateMerchantInfo', merchantInfo)
    },
    updateMerchantUser({commit}, mercharntUser){
      storage.set('merchantUser', mercharntUser)
      commit('updateMerchantUser', mercharntUser)
    },
    updateMerchantItem ({commit, dispatch, state}, data) {
      commit('updateMerchantItem', data)
      dispatch('updateMerchantInfo', state.merchantInfo)
    },
    updateToken ({commit}, token) {
      storage.set('token', token)
      commit('updateToken', token)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant.js